var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-dialog',{staticClass:"pa-10",attrs:{"width":"auto"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-img',_vm._g(_vm._b({staticClass:"ml-10",style:({
    width: '100px',
    height:'100px'
  }),attrs:{"src":_vm.imgurl}},'v-img',attrs,false),on))]}}]),model:{value:(_vm.isZoomOut),callback:function ($$v) {_vm.isZoomOut=$$v},expression:"isZoomOut"}},[_c('v-card',[_c('img',{attrs:{"src":_vm.imgurl}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }